import { Injectable, Input } from '@angular/core';

@Injectable()
export abstract class ListSelectableClass {
  selected: Array<any> = [];
  selectedOnPage: any = {};
  page = 1;
  protected _items = [];

  constructor() {}

  isChecked(item: any): boolean {
    return this.selected.findIndex((s) => s.id === item.id) !== -1;
  }

  onToggleSelected(item: any): void {
    const i = this.selected.findIndex((s) => s.id === item.id);
    this.selectedOnPage[this.page] = this.selectedOnPage[this.page] || 0;

    if (i === -1) {
      this.selected = [...this.selected, item];
      this.selectedOnPage[this.page]++;
    } else {
      this.selected = [
        ...this.selected.slice(0, i),
        ...this.selected.slice(i + 1),
      ];
      this.selectedOnPage[this.page]--;
    }
  }

  onToggleSelectAll(): void {
    if (
      !this.selectedOnPage[this.page] ||
      this.selectedOnPage[this.page] !== this._items.length
    ) {
      this._items.forEach((i) => {
        if (this.selected.findIndex((s) => s.id === i.id) === -1) {
          this.onToggleSelected(i);
        }
      });
    } else {
      this._items.forEach((i) => {
        if (this.selected.findIndex((s) => s.id === i.id) !== -1) {
          this.onToggleSelected(i);
        }
      });
    }
  }

  onUnselectAll(): void {
    this.selected = [];
    this.selectedOnPage = {};
  }
}
